import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import LoadingBar from "./loadingBar";
import LoadingSkeleton from "./LoadingSkeleton";
const LoadingDetails = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    function marginTopLoadingBar() {
        let loadingBar = document.getElementById('loading-bar-container');
        let navbar = document.getElementsByClassName('header')[0];
        if (loadingBar && navbar && windowWidth < 768) {
            loadingBar.style.marginTop = (navbar.clientHeight - 1) + 'px';
        }
    }
    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        marginTopLoadingBar();
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    useEffect(() => {
        marginTopLoadingBar();
    }, [windowWidth]);
    marginTopLoadingBar();
    return (windowWidth > 768 ? (_jsxs(_Fragment, { children: [_jsx(LoadingBar, {}), _jsx(LoadingSkeleton, {})] })) : (_jsxs(_Fragment, { children: [_jsx(LoadingBar, {}), _jsx(LoadingSkeleton, {})] })));
};
export default LoadingDetails;
